import { FC } from 'react';

const RecentlyAddedIndicatorV2: FC = () => {
  return (
    <div className="absolute -top-[3px] -right-[3px] w-2 h-2 rounded-full bg-blue-600 z-[1]" />
  );
};

export default RecentlyAddedIndicatorV2;
